// extracted by css-extract-rspack-plugin
export default {"root":"FooterWrapper_root__DCAsm"};